import { Select as MantineSelect } from '@mantine/core';
import { useDisclosure, useFocusWithin } from '@mantine/hooks';
import cx from 'clsx';
import { FC, memo } from 'react';
import defaultStyles from 'src/components/Form/styles.default.module.css';
import { Icon } from 'src/components/Icon';
import { useFormContext } from 'src/form';

import styles from './styles.module.css';

type Option = {
  label: string;
  value: string;
};

type Props = {
  name: string;
  label: string;
  placeholder: string;
  data: Option[];
  width?: number;
  maxWidth?: number;
};

export const Select: FC<Props> = memo((props) => {
  const { ref, focused } = useFocusWithin();
  const [dropdownOpened, { toggle }] = useDisclosure();

  const form = useFormContext();
  const formProps = form.getInputProps(props.name);

  return (
    <MantineSelect
      classNames={{
        dropdown: styles.dropdown,
        input: defaultStyles.input,
        label: defaultStyles.label,
        option: styles.option,
        options: styles.options,
        root: cx({
          [defaultStyles.root]: true,
          [defaultStyles.rootFocused]: focused,
        }),
        section: styles.section,
      }}
      checkIconPosition="right"
      comboboxProps={{
        transitionProps: { duration: 150, transition: 'fade' },
      }}
      dropdownOpened={dropdownOpened}
      onDropdownOpen={toggle}
      onDropdownClose={toggle}
      ref={ref}
      rightSection={
        <Icon
          className={cx({
            [styles.icon]: true,
            [styles.iconAnimated]: dropdownOpened,
          })}
          name="navigationArrow"
        />
      }
      withAsterisk={false}
      {...props}
      {...formProps}
    />
  );
});
